// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2zcPK","title":"Images90_title__ZhuEo","images":"Images90_images__25FEN"};